import { abyssColors } from '@/theme/colors';

export const accordionStyle = {
  boxShadow: 'none',
  background: 'none',
  '&:before': { display: 'none' },
  borderRadius: 0,
  '&::before': {
    display: 'none',
  },
  '&.MuiAccordion-root::before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0px !important',
  },
  '& .MuiAccordionSummary-root': {
    padding: '1.6rem 0.8rem',
    gap: '0.8rem',
    minHeight: 'fit-content',
  },
  borderBottom: `0.1rem solid ${abyssColors.primary[100]}`,
  '&.Mui-expanded': {
    borderBottom: 0,
  },
};

export const accordionSummaryStyle = {
  backgroundColor: abyssColors.primary[50],
  '&.MuiAccordionSummary-root': {
    gap: '1.6rem',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(0deg)',
    transition: 'transform 0.2s ease-in-out',
    '&.Mui-expanded': {
      transform: 'rotate(180deg)',
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root': {
    color: abyssColors.primary[300],
  },
};
